import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = 'https://qdeoqcvmbnrmzfdstjjr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFkZW9xY3ZtYm5ybXpmZHN0ampyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI4MDY0NDcsImV4cCI6MjA3ODM4MjQ0N30.wXdVe9HgfejvIp53R-LjUM8JKpRUAvk9irT8BehFb40';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
